module.exports = __webpack_public_path__ + "img/dicoding-1.89ce4ed3.png";